var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"app"}},[(_vm.pageName !='categorizer'
  && _vm.pageName !='segregator' 
  && _vm.pageName !='summarypage'
     && _vm.pageName !='customerregistration'
      && _vm.pageName !='forensicsdashboard'
      && _vm.pageName != 'partnerforensics'
      && _vm.pageName != 'partnerapproval'
      && _vm.pageName != 'partnerqueries'
      && _vm.pageName != 'gstmanagement'
      && _vm.pageName !='vendordetails'
      && _vm.pageName !='workbench'
      && _vm.pageName !='reports' 
      && _vm.pageName !='login' 
      && _vm.pageName !='home' 
      && _vm.pageName !='registerpage'
      && _vm.pageName !='resetpassword'
      && _vm.pageName !='changepasswordpage'
      && _vm.pageName.toLowerCase() !='grievanceinternational')?_c('supportformmodal'):_vm._e(),(_vm.pageName !='onboardingdetails' 
    && _vm.pageName !='workbench' 
    && _vm.pageName.toLowerCase() !='categorizer'
     && _vm.pageName.toLowerCase() !='customerregistration'
      && _vm.pageName.toLowerCase() !='forensicsdashboard'
      && _vm.pageName.toLowerCase() !='vendordetails'
      && _vm.pageName.toLowerCase() !='workbench'
      && _vm.pageName.toLowerCase() !='reports' 
      && _vm.pageName.toLowerCase() !='partnerqueries'
      && _vm.pageName.toLowerCase() !='grievanceinternational')?_c('helpLinks',{staticStyle:{"margin-right":"0px","margin-top":"0px"},attrs:{"variant":'outline-none'}}):_vm._e(),(_vm.pageName !='onboardingdetails' && _vm.pageName !='workbench' 
    && _vm.pageName.toLowerCase() !='categorizer'
     && _vm.pageName.toLowerCase() !='customerregistration'
      && _vm.pageName.toLowerCase() !='forensicsdashboard'
      && _vm.pageName.toLowerCase() !='vendordetails'
      && _vm.pageName.toLowerCase() !='workbench'
      && _vm.pageName.toLowerCase() !='reports' 
      && _vm.pageName.toLowerCase() !='partnerqueries'
      && _vm.pageName.toLowerCase() !='grievanceinternational')?_c('appChat'):_vm._e(),_c(_vm.layout,{tag:"component"},[_c('router-view')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }